<template>
	<div class="the-topbar-wrapper">
		<div class="the-topbar-header">
			<div class="the-page-title">
				<!-- <title-page :title="title"></title-page> -->
			</div>
			<div class="d-flex justify-content-between align-items-center pb-0">
				<div class="select-option" @click="selectLocation">
					<span>{{ locationNameSelected }}</span>
					<span>
						<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M4.99988 5.69512C5.19214 5.68984 5.36792 5.62129 5.51074 5.47363L9.68555 1.3709C9.8064 1.25488 9.87231 1.10723 9.87231 0.933203C9.87231 0.585156 9.58667 0.305664 9.22412 0.305664C9.04834 0.305664 8.87805 0.374219 8.75171 0.495508L5.00537 4.19219L1.24805 0.495508C1.1217 0.379492 0.956909 0.305664 0.775635 0.305664C0.413086 0.305664 0.127441 0.585156 0.127441 0.933203C0.127441 1.10723 0.193359 1.25488 0.314209 1.3709L4.49451 5.47363C4.64282 5.62129 4.80762 5.69512 4.99988 5.69512Z"
								fill="black"
							/>
						</svg>
					</span>
				</div>

				<el-popover 
					trigger="click"
					placement="bottom"
				>
					<el-button 
						slot="reference" 
						class="logout-btn"
					>
						<div class="user-img">
							<span><img :src="defaultUserImg"></span>
							<span>{{userLogin}}</span>
							<span>
								<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M4.99988 5.69512C5.19214 5.68984 5.36792 5.62129 5.51074 5.47363L9.68555 1.3709C9.8064 1.25488 9.87231 1.10723 9.87231 0.933203C9.87231 0.585156 9.58667 0.305664 9.22412 0.305664C9.04834 0.305664 8.87805 0.374219 8.75171 0.495508L5.00537 4.19219L1.24805 0.495508C1.1217 0.379492 0.956909 0.305664 0.775635 0.305664C0.413086 0.305664 0.127441 0.585156 0.127441 0.933203C0.127441 1.10723 0.193359 1.25488 0.314209 1.3709L4.49451 5.47363C4.64282 5.62129 4.80762 5.69512 4.99988 5.69512Z"
										fill="black"
									/>
								</svg>
							</span>
						</div>
					</el-button>
					<span 
						class="text-danger text-bold text-center cursor d-block"
						@click="logout()"
					>Đăng xuất</span>
				</el-popover>
			</div>
		</div>

		<slot name="custom-btn">
			<div class="the-csf-end">
				<!-- <base-button type="button" variant="__primary" v-html="icon"></base-button> -->
			</div>
		</slot>

		<LayoutPopup id="chon-chi-nhanh">
			<template #title>Chọn chi nhánh</template>
			<template #content>
				<div 
					class="content-block"
					v-for="location in listLocation" 
					:key="location.coLocationId"
					@click="setLocation(location)"
				>
					<p>{{location.name}}</p>
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
							<path d="M15.1266 6.69608C15.1266 6.46254 15.0287 6.23654 14.8554 6.0708L9.9059 1.1213C9.71003 0.932966 9.50663 0.850098 9.29569 0.850098C8.81355 0.850098 8.46701 1.1891 8.46701 1.64865C8.46701 1.88972 8.56494 2.09312 8.71561 2.24379L10.4106 3.96143L12.5954 5.9578L10.8476 5.85233H1.71701C1.21226 5.85233 0.865723 6.19887 0.865723 6.69608C0.865723 7.18576 1.21226 7.5323 1.71701 7.5323H10.8476L12.5954 7.42683L10.4106 9.4232L8.71561 11.1408C8.56494 11.2915 8.46701 11.4949 8.46701 11.736C8.46701 12.1955 8.81355 12.5345 9.29569 12.5345C9.50663 12.5345 9.71003 12.4517 9.89083 12.2784L14.8554 7.31383C15.0287 7.14809 15.1266 6.92208 15.1266 6.69608Z" fill="#3E69F6"/>
							</svg>
					</span>
				</div>
			</template>
			<template #control-right> 
				<BaseButton 
					@click="hidePopup('selectLocation')"
          size="sm"
					variant="outline"
					:disabled="true"
				>
          Thoát
        </BaseButton>
			</template>
		</LayoutPopup>
	</div>
</template>

<script>
import $store from "@/state/store"

import VueCookies from 'vue-cookies'
import getListLocation from "@/mixins/location/getListLocationDashboard"
import baseButton from '../../components/base-button.vue'
import { RoleService } from '@/services/nextshop/role.service'
import { AuthService } from '@/services/auth.service'
import { PackageService } from "@/services/nextshop/package.service"
import { removeStorageItem } from '@/utils/auth'

export default {
	components: { baseButton },
	name: "TheTopBar",
	mixins: [getListLocation],
	data() {
		return {
			locationNameSelected: JSON.parse(localStorage.getItem("locationName")) ? JSON.parse(localStorage.getItem("locationName")).name :  "",
			listLocation: [],
			userLogin: JSON.parse(localStorage.getItem("auth.currentUser")).name,
			dataSearch: "",
			defaultUserImg: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAB9CAYAAACBBdAPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASDSURBVHgB7d3bUttGHIDxlVY+yDZgmpDmEXrZdHoB6XQmvFEfqZd9izDTZtqbDrnksi9QMAafdNpoHfTHyeAEO2C8q+8344wUJh4Sf9ZqV3II1I2//vn3UBXhYRCovkItlK/1IDfq/a9Hr07m+/aXP/8+fRMq9UahngJz9svhT38Eb9+e9ptt9ZtCrZUHg9/DVit/qVB7mQl/CI3RbYXa07pohwq4QQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEABEpD41Go8b1eNRUTyQMQvPd/v5Ea22UQ7yLwRgTDIaXT/5fIJ9fXMQHz5+PlUO8GyayogjUFijMdnwfq/BymFh08OyZvDsvh1etJE203e52e0mn3crUGhafp9PppN04Tu12Mkv05fVVSznK+xiazVZ+u3d1+/tRlH/6tVXcPo8OdVE9T5rnTh9pmU1AeH9keGx5kYdJMpsPGWmaOf3m8i6GKAzN4nnCov7+/tTk2fzETjeahXoA4/G4YR/KA97FEASBWXYu0NC6UFor3I1h4hsF5cKSLgO023m5xmHy3LkpZcXJGOwK4/RmnH5sWkdmp9tNlq0m9uJOsruzk8y/r8m4MRgMnP2ZX87FYEPY9ArjbDaNvj94MVKec+7sN8nSjQ/6WZaF+ZLDf1EODfZrucPDQ8Xpc4a4HWetNVcRv6ow6j5HoNHoumkfygNOxxCVq4jduJOqRzBfTRxeqjphBRLCq6mlHben0+n879Ttdh/liPG5nd7OjNnElknTNDwfXMT2ZM/u2xPN/b3+VOHevBkmjCmCKgRrMpmwoLYib/7BGuW1BrsUbe90svtxHH9xljEcDltX5SzA3tfQ392dqTWVAWo7PNjtJEmcXuv2JgYbwsHBi7FdlLLXINqdztIYqhDsdjUtXDeIyXQS2YfygFeHUhvB117UxRAq3xrEXZrN5po3zjydWo2rF5eD9rLLzasE0YnjNNTh0kvgrahRxL3eRmYzD8mrGKoZhX1Xfj6T+FIIlfsGYaetm5q6bpKXU8tqVtHf3ZvZc4n7hFCxQdiZSa/3ce2gTryIwYbw/8V5Z/FikX3x7dm9/UBLdSfzfdk/mzl+C9s6nI/hrhAqi+sOq1o1IB84HYOd45chNH24fLwNnI7Bl/n9tuCqJQQxQDgXQyPUD/J5h1WEUVS49vH6dTg35nbLlb10/immZEN3R+tib6//YMvU28y5GOwiEvcpPA7OGSCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAFzeR5OwyQZnCnUnlbpf+Hx8fG0PDycKNRXYc5ev/75TH6cz7t3pz+a0BwGKnipUAvGqIEO1Pujo1cndv8DV7mscE6zIbwAAAAASUVORK5CYII=",
			checkChangePlan: false
		}
	},
	async created() {
		this.listLocation = await this.getListLocation()
		console.log(this.listLocation)
		if(this.listLocation.length == 0){
			let inforUsers = JSON.parse(localStorage.getItem("auth.currentUser"))
			await this.merchantPlanConfigs()
			if(this.checkChangePlan){
				if(inforUsers.role == 'employee'){
					this.$router.push('/forbidden')
				}else{
					this.$router.push('/package-select-v2')
				}
			}
		}else{
			this.checkLocation()
		}
	},

	methods: {
		selectLocation() {
			if (this.listLocation) {
				this.showPopup('chon-chi-nhanh')
			}
		},

		logout() {
			AuthService.makeLogout()
			localStorage.removeItem('locationName')
		},

		async setLocation(data) {
			try {
				this.locationNameSelected = data.name
				$store.commit("auth/SET_CURRENT_LOCATION", data.coLocationId);
				VueCookies.set("LID", data.coLocationId) 
				VueCookies.set("IID", (data.inventories  &&  data.inventories.length > 0) ? data.inventories[0].coInventoryId : '')
				localStorage.setItem("locationName", JSON.stringify(data))
				localStorage.setItem("inventoryID", (data.inventories &&  data.inventories.length > 0) ? data.inventories[0].coInventoryId : '');
				await RoleService.getListPermissionsUser()
				this.hidePopup('chon-chi-nhanh')
				location.reload()
			} catch (error) {
				console.log(error);
			}
		},
		
		checkLocation() {
			if (!JSON.parse(localStorage.getItem("locationName"))) {
				this.showPopup('chon-chi-nhanh')
			}
		},

		async merchantPlanConfigs() {
			try {
				const response = await PackageService.merchantPlanConfigs()
				if (response.success) {
					if(response.data.plan == null || response.data.plan == ''){
						removeStorageItem('locationName')
						AuthService.packageBackHome()
					}else{
						this.checkChangePlan = response.data.planChanged
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.the-topbar-wrapper {
	background: #fff;
	width: calc(100% - 300px);
	position: absolute;
	right: 0;
	z-index: 10;

	.the-topbar-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 64px;
		padding: 12px 24px;
		box-shadow: inset 0px -1px 0px #dddddd;

		span {
			font-size: 16px;
			font-weight: 500;
			line-height: 25.6px;
			color: #000;
		}

		.select-option {
			margin-right: 30px;

			span {
				font-size: 14px;
				margin-right: 8px;
			}
		}

		.user-img {
			padding: 1px;
			border-radius: 20px;

			span {
				font-size: 14px;
				margin-right: 8px;
				
				img {
					width: 40px;
					height: 40px;
					border-radius: 50%;
				}
			}
			
			&:hover {
				cursor: pointer;
				background: #f2f2f2;
			}
		}
	}
}

.select-option {
	cursor: pointer;
}

.__popup {
	.content-block {
		margin-bottom: 20px;
		padding: 12px 13px;
		border: 1px solid #DDDDDD;
		box-sizing: border-box;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
		color: #000;
		line-height: 22.4px;
		position: relative;

		span {
			svg {
				position: absolute;
				top: 16px;
				right: 16px;

			}
		}

		p {
			margin-bottom: 0;
		}
	}
}

::v-deep .page-title-box {
	padding-bottom: 0 !important;

	.font-weight-bold {
		margin-bottom: 0;
	}

}

::v-deep .the-input-box {
	height: 44px;
}

.logout-btn {
	border: none;
	background: transparent;
	cursor: initial;
	padding: 0;

	&:hover,
	&:focus {
		border: none;
		background: transparent;
	}
}
</style>
